import { render, staticRenderFns } from "./CategoryDeleteConfirmation.vue?vue&type=template&id=3db1787d&"
import script from "./CategoryDeleteConfirmation.vue?vue&type=script&lang=ts&"
export * from "./CategoryDeleteConfirmation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports